import { render, staticRenderFns } from "./ProgramAdd.vue?vue&type=template&id=89fa7082"
import script from "./ProgramAdd.vue?vue&type=script&lang=js"
export * from "./ProgramAdd.vue?vue&type=script&lang=js"
import style0 from "./ProgramAdd.vue?vue&type=style&index=0&id=89fa7082&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports